<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="danger" style="margin-right: 10px">新 增</el-button>
      <el-input v-model="tableQuery.name" style="width: 160px;" @change="selectPage" placeholder="请输入岗位名称"></el-input>
      <el-button type="danger" style="margin: 0 10px">搜 索</el-button>
    </div>
    <el-table border class="table" :data="tableData" height="600px" v-loading="tableQuery.loading" empty-text="空空如也～ 新增一条吧！">
      <el-table-column prop="name" label="岗位名称" width="280" show-overflow-tooltip/>
      <el-table-column prop="addTime" label="所属部门" show-overflow-tooltip/>
      <el-table-column prop="addTime" label="岗位类型" show-overflow-tooltip/>
      <el-table-column prop="addTime" label="岗位级别" show-overflow-tooltip/>
      <el-table-column prop="addTime" label="岗位描述" show-overflow-tooltip/>
      <el-table-column prop="addTime" label="创建日期" width="180"/>
      <el-table-column label="操作" width="110" align="center">
        <template #default="scope">
          <div style="margin-right: 4px;">
            <el-button type="text" size="small" style="margin-right: 10px;color:#409EFF"
                       @click.prevent="updateItem(scope.row)">编辑
            </el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.id)">
              <el-button slot="reference" type="text" size="small" style="color: red;">删除</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: "Job",
  components: {
  },
  data() {
    return {
      tableQuery:{
        total:0
      },
      tableData:[]
    }
  },
  methods: {
    selectPage(){

    },
    changePage(){

    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>